var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C3.57565 3 3.16869 3.16857 2.86863 3.46863C2.56857 3.76869 2.4 4.17565 2.4 4.6V9.4H0L3.2 12.6L6.4 9.4H4V4.6H9.6L11.2 3H4ZM12 6.2H9.6L12.8 3L16 6.2H13.6V11C13.6 11.4243 13.4314 11.8313 13.1314 12.1314C12.8313 12.4314 12.4243 12.6 12 12.6H4.8L6.4 11H12V6.2Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircle);
export default __webpack_public_path__ + "static/media/icon-circle.3c07ea7b25bafe5d7028c3cdb3bf1072.svg";
export { ForwardRef as ReactComponent };